import { useEffect } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import useNavigate from '../../../hooks/useNavigate';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollIntoView = ({
  id,
  children
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.hash === `#${id}`) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
        navigate(oldLocation => Object.assign({}, oldLocation, {
          hash: ''
        }), {
          method: 'replace'
        });
      }
    }
  }, [id, location.hash, navigate]);
  return /*#__PURE__*/_jsx("section", {
    id: id,
    children: children
  });
};